import i18n from '@/utils/i18n';
import React from 'react';
import { ButtonSize } from '@/experiences/sales-portal/components/button';
import { ErrorState } from '@/experiences/sales-portal/components/error-state';
import { useTheme } from '@/contexts/theme-context';

interface ManagerSectionErrorProps {
  onRetry: () => void;
}

export const ManagerSectionError: React.FC<ManagerSectionErrorProps> = ({
  onRetry,
}) => {
  const theme = useTheme();

  return (
    <ErrorState
      ctaProps={{
        size: ButtonSize.Small,
        style: { paddingHorizontal: theme.sk.spacing.spaceMedium },
        width: 'auto',
      }}
      description={i18n.t('sales_portal.prospects.manager.error_description')}
      onPress={onRetry}
      title={i18n.t('sales_portal.prospects.manager.error_title')}
    />
  );
};
